import * as React from 'react'

import {withContextAsProp} from '../utils/contexts'

export const LocatorContext = React.createContext<string | null>(null)
export const useLocator = () => React.useContext(LocatorContext)
export const withLocator = withContextAsProp(LocatorContext, 'locator')
